import DrawerView from "../constants/DrawerView";

/**
 * Cria o state inicial do menu de configuração avançada de tendências.
 * @returns State de configurações avançadas de tendências.
 */
const EmptyAdvancedSettingsDrawerMenuFactory = function()
{
	return {
		isCustomDomainChecked:           false,
		isStratificationsChecked:        false,
		isCustomDomainComparisonChecked: false,
		isDrawerOpen:                    false,
		currentDrawerView:               DrawerView.HOME,
	};
};

export default { EmptyAdvancedSettingsDrawerMenuFactory };